import { render, staticRenderFns } from "./ViewCalenderItem.vue?vue&type=template&id=c1b39632&scoped=true"
import script from "./ViewCalendarItem.ts?vue&type=script&lang=ts&external"
export * from "./ViewCalendarItem.ts?vue&type=script&lang=ts&external"
import style0 from "./ViewCalenderItem.scss?vue&type=style&index=0&id=c1b39632&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b39632",
  null
  
)

export default component.exports